import React from 'react';
import PropTypes from 'prop-types';
import { GlobalOutlined } from '@ant-design/icons';

const LABEL = {
  SLACK: 'Slack',
  TEAMS: 'Teams',
  PUMBLE: 'Pumble',
  WEB: 'Web',
};

function TeamsSvg({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <path
        fill="#5059C9"
        d="M21.5 9.5a2 2 0 100-4 2 2 0 000 4zm-7.25-.5a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zM23 11h-3.5a.5.5 0 00-.5.5v5.25a3 3 0 002.25 2.9A3.5 3.5 0 0023 16.25v-4.75a.5.5 0 00-.5-.5zM17.5 11h-8a.5.5 0 00-.5.5V18a4 4 0 008 0v-6.5a.5.5 0 00-.5-.5z"
      />
      <path
        fill="#7B83EB"
        d="M9 5a3 3 0 100 6 3 3 0 000-6zM1 7.5v9a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0011.5 6h-9A1.5 1.5 0 001 7.5z"
      />
      <path fill="#fff" d="M9.5 9.5h-5V11h1.75v5h1.5v-5H9.5z" />
    </svg>
  );
}
TeamsSvg.propTypes = { size: PropTypes.number.isRequired };

function PumbleSvg({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <circle cx="12" cy="12" r="11" fill="#F23E2F" />
      <path
        fill="#fff"
        d="M9 6.5h4.6c2.5 0 4.4 1.8 4.4 4.2 0 2.5-1.9 4.2-4.4 4.2H11v2.6H9V6.5zm2 6.6h2.4c1.4 0 2.4-.9 2.4-2.4s-1-2.4-2.4-2.4H11v4.8z"
      />
    </svg>
  );
}
PumbleSvg.propTypes = { size: PropTypes.number.isRequired };

// `showTitle={false}` drops the native browser tooltip — use it when the logo
// already sits inside a richer tooltip (e.g. the Workspaces "Int." column).
function PlatformLogo({ type, size, showTitle }) {
  const label = LABEL[type] || type;
  if (type === 'SLACK') {
    return (
      <img
        src="/slacklogo.png"
        alt={label}
        title={showTitle ? label : undefined}
        style={{ width: size, height: size, verticalAlign: 'middle' }}
      />
    );
  }
  if (type === 'TEAMS') return <TeamsSvg size={size} />;
  if (type === 'PUMBLE') return <PumbleSvg size={size} />;
  if (type === 'WEB') {
    return (
      <GlobalOutlined
        title={showTitle ? label : undefined}
        style={{ fontSize: size, verticalAlign: 'middle', color: '#888' }}
      />
    );
  }
  return <span>{label}</span>;
}

PlatformLogo.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.number,
  showTitle: PropTypes.bool,
};

PlatformLogo.defaultProps = {
  size: 16,
  showTitle: true,
};

export default PlatformLogo;
